<template>
  <head>
    <title>{{ $t("dashboard.types") }}</title>
  </head>
  <div class="types-view">
    <SideBar>
      <div class="container bg-light h-100 overflow-scroll">
        <div class="d-flex justify-content-center align-items-center mt-5 mb-3">
          <div class="w-100 d-flex justify-content-start align-items-center">
            <h3>{{ $t("dashboard.types") }} ({{ data.length }})</h3>
          </div>
          <div class="w-100 d-flex justify-content-end align-items-center">
            <button
              type="button"
              class="add-btn"
              @click="$router.push('/admin-add-types')"
            >
              {{ $t("dashboard.AddType") }}
            </button>
          </div>
        </div>
        <div class="search-bar w-100 my-4">
          <input
            type="text"
            class="my-inp w-50"
            style="border: 1px solid black"
            :placeholder="$t('dashboard.SearchTypes')"
            v-model="search_for"
            v-on:input="SearchByName()"
          />
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.NameAr") }}</th>
                <th scope="col">{{ $t("dashboard.NameEn") }}</th>
                <th scope="col">{{ $t("dashboard.edit") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in shown_data" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>{{ item.name_ar }}</td>
                <td>{{ item.name_en }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-success"
                    @click="$router.push('/admin-add-types?id=' + item.id)"
                  >
                    {{ $t("dashboard.edit") }}
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click="DeleteType(item.id)"
                  >
                    {{ $t("dashboard.delete") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </SideBar>
  </div>
</template>

<script>
import SideBar from "@/components/AdminDashboard/SideBar.vue";
import store from "@/store";
import axios from "axios";
export default {
  name: "types-view",
  data() {
    return {
      data: [],
      shown_data: [],
      search_for: "",
    };
  },
  components: {
    SideBar,
  },
  methods: {
    getData() {
      axios
        .get(store.state.server + "get-all-types")
        .then((response) => {
          this.data = response.data;
          this.SearchByName();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SearchByName() {
      this.shown_data =
        this.search_for === ""
          ? this.data
          : this.data.filter(
              (item) =>
                item.name_ar.includes(this.search_for) ||
                item.name_en
                  .toLowerCase()
                  .includes(this.search_for.toLowerCase())
            );
    },
    DeleteType(id) {
      let conf = window.confirm("هل تريد الحذف؟");
      if (conf) {
        axios
          .get(store.state.server + "delete-type/" + id)
          .then((response) => {
            if (response.status == 200) {
              location.reload();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
